
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 220 220"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('g',{attrs:{"id":"Play"}},[_c('circle',{attrs:{"cx":"110","cy":"110","r":"110","fill":"#03508c"}}),_c('circle',{staticClass:"cls-2",attrs:{"fill":"#fff","cx":"136.53","cy":"80.86","r":"15.62"}}),_c('path',{staticClass:"cls-2",attrs:{"fill":"#fff","d":"M88.33 64.87L63.56 85.93l30.63 10.93-5.86-31.99zM125.03 122.12h28.94v28.94h-28.94z"}}),_c('path',{staticClass:"cls-2",attrs:{"fill":"#fff","transform":"rotate(-45 81.922 136.577)","d":"M61.47 134.59h40.93v4H61.47z"}}),_c('path',{staticClass:"cls-2",attrs:{"fill":"#fff","transform":"rotate(-45 81.934 136.582)","d":"M79.94 116.12h4v40.93h-4z"}})])])])])
          )
        }
      }
    